import { useUpdateCurrentUserMutation } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import { getIsChatConnected } from 'gcs-common/slices/chatConnection/chatConnectionSelectors';
import {
  getCurrentFriendlyName,
  getCurrentUserCompany,
  getCurrentUserImage,
  getHasCurrentUserImage,
} from 'gcs-common/slices/currentUser/currentUserSelectors';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../../Button/Button';
import ModalWithCloseButton from '../../PopUpModal/ModalWithCloseButton/ModalWithCloseButton';
import SelectPhotoSourceButtons from '../../SelectPhotoSourceButtons/SelectPhotoSourceButtons';
import SettingsInput from '../SettingsInput/SettingsInput';
import styles from './styles.module.scss';

const ProfileEditModal = ({
  isOpen,
  onRequestClose,
  label = 'Modal',
}: {
  isOpen: boolean;
  onRequestClose: () => void;
  label: string;
}) => {
  const currentFriendlyName = useSelector(getCurrentFriendlyName);
  const currentUserImage = useSelector(getCurrentUserImage);
  const currentUserHasImage = useSelector(getHasCurrentUserImage);
  const currentCompany = useSelector(getCurrentUserCompany);
  const isChatConnected = useSelector(getIsChatConnected);

  const [userCompany, setUserCompany] = useState(currentCompany || '');
  const [userName, setUserName] = useState(currentFriendlyName || '');
  const [openSelectPhotoButtons, setOpenSelectPhotoButtons] = useState(false);

  const updateCurrentUserMutation = useUpdateCurrentUserMutation();

  useEffect(() => {
    setUserCompany(currentCompany || '');
  }, [currentCompany]);

  useEffect(() => {
    setUserName(currentFriendlyName || '');
  }, [currentFriendlyName]);

  const updateRemoteCompany = async (newCompany: string) => {
    if (newCompany && newCompany.length > 0) {
      updateCurrentUserMutation.mutate({
        body: {
          userCompany: newCompany,
        },
      });
    }
  };

  const updateRemoteName = async (newName: string) => {
    if (newName && newName.length > 0) {
      updateCurrentUserMutation.mutate({
        body: {
          friendlyName: newName,
        },
      });
    }
  };

  const toggleSelectPhotoButtons = () => {
    setOpenSelectPhotoButtons(!openSelectPhotoButtons);
  };

  return (
    <ModalWithCloseButton label={label} onRequestClose={onRequestClose} isOpen={isOpen}>
      <div className={styles.container}>
        <div className={styles.profileContainer}>
          <button type="button" disabled={!isChatConnected} onClick={toggleSelectPhotoButtons}>
            <div className={styles.profileImage}>
              {!currentUserHasImage ? (
                <div className={styles.overlay}>Bild Hinzufügen</div>
              ) : (
                <div className={styles.overlay}>Profilbild ändern</div>
              )}
              <img src={currentUserImage} className={styles.profileImagePic} alt="Profilbild des Users" />
            </div>
          </button>

          {openSelectPhotoButtons && <SelectPhotoSourceButtons toggleSelectPhotoButtons={toggleSelectPhotoButtons} />}

          <div className={styles.profileDetailsContainer}>
            <SettingsInput
              name="Dein Name"
              onFinish={updateRemoteName}
              value={userName}
              onChange={setUserName}
              disabled={!isChatConnected}
            />

            <SettingsInput
              name="Firma"
              onFinish={updateRemoteCompany}
              value={userCompany}
              onChange={setUserCompany}
              disabled={!isChatConnected}
            />
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <Button onClick={onRequestClose} className={styles.button}>
            Schließen
          </Button>
        </div>
      </div>
    </ModalWithCloseButton>
  );
};

ProfileEditModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default ProfileEditModal;
